export default "__VITE_ASSET__AqG_ZXeg__"